import { UserSettingsService } from 'app/user/user-settings.service';
import { Order } from 'app/orders/order.model';
import { UIDialogData } from 'app/ui/dialog/dialog-injector';
import { Component, Inject } from '@angular/core';
import { UIDialogService } from 'app/ui/dialog/dialog.service';

@Component({
  selector: 'order-details',
  templateUrl: 'order-details.component.html',
  styleUrls: ['order-details.component.scss']
})
export class OrderDetailsComponent {
  constructor(
    @Inject(UIDialogData)
    public order: Order,
    private _dialogService: UIDialogService,
    private _userSettingsService: UserSettingsService
  ) { }

  serviceType() {
    return this._userSettingsService.serviceType;
  }

  close() {
    this._dialogService.close();
  }
}
